var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-tag funding-status",class:`funding-status--${_vm.status}`},[_vm._v(" "+_vm._s(_vm.statusName(_vm.status))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }